import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router-dom";
import {
  Button,
  Panel,
  Row,
  Col,
  ControlLabel,
  FormGroup,
  FormControl,
  Alert,
  Checkbox,
  Label,
} from "react-bootstrap";
import {
  HotelAction,
  updateOrderStore,
  updateOrder,
  validationError,
} from "../actions/hotels";
import { size, range, map, every } from "lodash";
import "react-dates/lib/css/_datepicker.css";
import "font-awesome/less/font-awesome.less";
import "hint.css/hint.css";

import { ApplicationState } from "../reducers";
import "./styles/hotels.less";
import { moneyFormat } from "../utils";
import { RoutedStepper } from "./Stepper";
import { DiscountCode, Guest, Order } from "../models/order";
import Cart from "./Cart";
// import {PackageDescription} from "../html/copy";
// import {Address, User} from "../models/user";
import {
  deliveryOptions /*, GeniePlusOptions*/,
  MemoryMakerOptions,
  suffixes,
  titles,
  tripInsurances,
} from "../enums";
import { PackageTotals, TotalProps } from "./PackageTotals";

interface Props extends RouteComponentProps<any> {
  order: Order;
  validationErrorMessage: string;
  updateOrder: (order: Order) => Promise<HotelAction>;
  updateOrderStore: (order: Order) => HotelAction;
  validationError: (msg: string) => HotelAction;
}

class Summary extends React.Component<Props> {
  public render(): JSX.Element {
    const smallDevice = window.matchMedia("(max-width: 400px)").matches;
    return (
      <div className="hotel-listing-c">
        <div className={smallDevice ? "" : "package-container"}>
          <div className="left m-b-l">
            <RoutedStepper />
          </div>
          <div className="right">{this.renderCart()}</div>
        </div>
      </div>
    );
  }

  public renderCart(): JSX.Element {
    if (!this.props.order) {
      return null;
    }
    return (
      <Panel bsStyle="primary" className="cart">
        <Panel.Heading>Your Package</Panel.Heading>
        <Panel.Body>
          <Cart />
          <h3 className="m-t">Guest Information</h3>
          {this.renderGuests()}
          <h3 className="m-t">Delivery Options</h3>
          {this.renderDeliverOptions()}
          <h3 className="m-t">Trip Interruption Insurance</h3>
          {this.renderInsurance()}
          <h3 className="m-t">Memory Maker</h3>
          {this.renderMemoryMaker()}
          {/* <h3 className="m-t">Genie+</h3>
                    {this.renderGeniePlus()} */}
          <h3 className="m-t">Totals</h3>
          <PackageTotals order={this.props.order} />
          <Row>
            <Col xs={12} style={{ textAlign: "right" }}>
              <Button bsStyle="success" onClick={() => this.goToCheckout()}>
                Checkout
              </Button>
            </Col>
          </Row>
        </Panel.Body>
      </Panel>
    );
  }

  private renderGuests(): JSX.Element {
    const guests: Guest[] = this.props.order.guests || [];
    const numGuests = 1; //this.numGuests();
    guests.length = numGuests;
    range(numGuests).forEach((n) => {
      let guest = guests[n];
      if (!guest) {
        guest = { firstName: "", middleName: "", lastName: "", title: "" };
        guests[n] = guest;
      }
      return guest;
    });

    return (
      <div>
        {this.props.validationErrorMessage && (
          <Alert bsStyle="danger">{this.props.validationErrorMessage}</Alert>
        )}
        {guests.map((guest, index) => {
          return (
            <Row key={index}>
              <Col lg={2} md={3}>
                <FormGroup>
                  <ControlLabel>Title *</ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={guest.title}
                    onChange={(e: any) => {
                      guest.title = e.target.value;
                      this.updateGuest(guest, index);
                    }}
                  >
                    <option value="" key="--" />
                    {map(titles, (title) => (
                      <option value={title.code} key={title.code}>
                        {title.name}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col lg={3} md={6}>
                <FormGroup>
                  <ControlLabel>First Name *</ControlLabel>
                  <FormControl
                    type="text"
                    value={guest.firstName}
                    onChange={(e: any) => {
                      guest.firstName = e.target.value;
                      this.updateGuest(guest, index);
                    }}
                  ></FormControl>
                </FormGroup>
              </Col>
              <Col lg={2} md={6}>
                <FormGroup>
                  <ControlLabel>Middle Name</ControlLabel>
                  <FormControl
                    type="text"
                    value={guest.middleName}
                    onChange={(e: any) => {
                      guest.middleName = e.target.value;
                      this.updateGuest(guest, index);
                    }}
                  ></FormControl>
                </FormGroup>
              </Col>
              <Col lg={3} md={6}>
                <FormGroup>
                  <ControlLabel>Last Name *</ControlLabel>
                  <FormControl
                    type="text"
                    value={guest.lastName}
                    onChange={(e: any) => {
                      guest.lastName = e.target.value;
                      this.updateGuest(guest, index);
                    }}
                  ></FormControl>
                </FormGroup>
              </Col>
              <Col lg={2} md={3}>
                <FormGroup>
                  <ControlLabel>Suffix</ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={guest.suffix}
                    onChange={(e: any) => {
                      guest.suffix = e.target.value;
                      this.updateGuest(guest, index);
                    }}
                  >
                    <option value="" key="--" />
                    {map(suffixes, (suffix) => (
                      <option value={suffix.code} key={suffix.code}>
                        {suffix.name}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
          );
        })}
      </div>
    );
  }

  private renderDeliverOptions(): JSX.Element {
    const order = this.props.order;
    return (
      <Row>
        <Col md={12}>
          <FormGroup>
            <ControlLabel>Delivery Method</ControlLabel>
            <FormControl
              componentClass="select"
              value={order.shippingMethod || ""}
              onChange={(e: any) => {
                order.shippingMethod = e.target.value;
                this.updateOrder(order);
              }}
            >
              {map(deliveryOptions, (deliveryOption) => (
                <option value={deliveryOption.code} key={deliveryOption.code}>
                  {deliveryOption.name}
                </option>
              ))}
            </FormControl>
          </FormGroup>
          <div>
            Ticket Confirmation codes for Magic Band linking and FastPass+
            reservations generally arrive within an hour. Please allow up to 24
            hours for codes to arrive.
          </div>
        </Col>
      </Row>
    );
  }

  private renderInsurance(): JSX.Element {
    const order = this.props.order;
    return (
      <Row>
        <Col md={12}>
          <FormGroup>
            <ControlLabel>Insurance</ControlLabel>
            <FormControl
              componentClass="select"
              value={order.insuranceTickets || 0}
              onChange={(e: any) => {
                order.insuranceTickets = e.target.value;
                this.updateOrder(order);
              }}
            >
              <option value={0} key="None">
                None
              </option>
              {map(tripInsurances, (insuranceOption) => (
                <option value={insuranceOption.code} key={insuranceOption.code}>
                  {insuranceOption.name}
                </option>
              ))}
            </FormControl>
          </FormGroup>
          {order.insuranceTickets == 0 ? null : (
            <div>
              <FormGroup>
                <Checkbox
                  checked={order.insuranceConfirmation}
                  onChange={(e: any) => {
                    order.insuranceConfirmation = e.target.checked;
                    this.updateOrder(order);
                  }}
                >
                  I have read and understand the Trip Interruption Insurance
                  Terms and Conditions*
                </Checkbox>
                <InsuranceTerms />
              </FormGroup>
            </div>
          )}
        </Col>
      </Row>
    );
  }
  private renderMemoryMaker(): JSX.Element {
    const order = this.props.order;
    return (
      <Row>
        <Col md={12}>
          <FormGroup>
            <ControlLabel>
              Purchase Memory Maker today and save $30!Plus receive Free 2 Day
              Express Shipping on your ticket purchase.
            </ControlLabel>
            <FormControl
              componentClass="select"
              value={order.memoryMaker ? "1" : "0"}
              onChange={(e: any) => {
                order.memoryMaker = e.target.value === "1";
                this.updateOrder(order);
              }}
            >
              {map(MemoryMakerOptions, (memoryOption) => (
                <option value={memoryOption.code} key={memoryOption.code}>
                  {memoryOption.name}
                </option>
              ))}
            </FormControl>
          </FormGroup>
          {order.memoryMaker && (
            <FormGroup>
              <Checkbox
                checked={order.memoryMakerConfirmation}
                onChange={(e: any) => {
                  order.memoryMakerConfirmation = e.target.checked;
                  this.updateOrder(order);
                }}
              >
                I have read and understand the Memory Maker Terms and
                Conditions*
              </Checkbox>
              <MMTerms />
            </FormGroup>
          )}
        </Col>
      </Row>
    );
  }

  // private renderGeniePlus(): JSX.Element {
  //     const order = this.props.order;
  //     return (
  //         <Row>
  //             <Col md={12}>
  //                 <FormGroup>
  //                     <ControlLabel>Include Genie+ and get access to Lightning Lane at select attractions at all 4 parks. Genie+ allows you to experience more each day by skipping the standby lines and going through the much faster Lightning Lanes. Price below includes tax!</ControlLabel>
  //                     <FormControl componentClass="select"
  //                                  value={order.geniePlus ? '1' : '0'}
  //                                  onChange={(e: any) => {
  //                                      order.geniePlus = e.target.value === '1';
  //                                      this.updateOrder(order);
  //                                  }}>
  //                         {map(GeniePlusOptions, gp => <option value={gp.code} key={gp.code}>{gp.name}</option>)}
  //                     </FormControl>
  //                 </FormGroup>
  //                 {order.geniePlus && <FormGroup>
  //                     <Checkbox checked={order.geniePlusConfirmation}
  //                               onChange={(e: any) => {
  //                                   order.geniePlusConfirmation = e.target.checked;
  //                                   this.updateOrder(order);
  //                               }}>
  //                         I have read and understand the Genie+ Terms and Conditions*
  //                     </Checkbox>
  //                     <GPTerms/>
  //                 </FormGroup>}
  //             </Col>
  //         </Row>
  //     );
  // }

  private numGuests(): number {
    const tickets = this.props.order.tickets || [];
    let adults = 0,
      children = 0;
    tickets.forEach((t) => {
      adults = Math.max(adults, t.quantityAdults);
      children = Math.max(children, t.quantityChildren);
    });
    return adults + children;
  }

  private updateGuest(guest: Guest, index: number) {
    const guests: Guest[] = this.props.order.guests || [];
    guests.length = this.numGuests();
    guests[index] = guest;
    this.props.order.guests = guests;
    this.props.updateOrderStore(this.props.order);
  }

  private updateOrder(order: Order) {
    this.props.updateOrder(order);
  }

  private validateGuests() {
    return every(this.props.order.guests, (guest: Guest) => {
      return guest.title && guest.firstName && guest.lastName;
    });
  }

  private goToCheckout() {
    if (!this.validateGuests()) {
      return this.props.validationError("Please enter all guest information");
    }
    if (
      this.props.order.insuranceTickets > 0 &&
      !this.props.order.insuranceConfirmation
    ) {
      return this.props.validationError(
        "You must confirm you understand the trip insurance terms and conditions"
      );
    }
    this.props.updateOrder(this.props.order).then(() => {
      this.props.history.push("/checkout");
    });
  }
}

const connected = connect(
  (state: ApplicationState) => ({
    order: state.hotels.order,
    validationErrorMessage: state.hotels.validationError,
  }),
  {
    updateOrderStore,
    validationError,
    updateOrder,
  }
)(Summary);

export default withRouter<any>(connected);

const InsuranceTerms: React.SFC = () => {
  const terms = `Trip Cancellation/Trip Interruption Terms:
Coverage and benefits include the following, subject to certain exclusions and limitations:
Trip Cancellation/Trip Interruption (100% of insured Trip Cost), including coverage for nonrefundable prepaid tickets due to covered reasons such as:
Involuntary termination or layoff after the effective date of coverage and you have been an active employee with the same employer for at least one year.
Being called into active military service, or having military leave revoked, or being reassigned.
A disabling sickness, injury or death causing trip to be canceled.
Hurricane or inclement weather causing delay or cancellation of travel.
Terms of Coverage:
Your purchase is protected when one or more of the covered reasons become applicable to the individual who made the purchase. Proof of reason is required and must be submitted to Park Savers within 7 days of discovery/issue. All claims may be sent to: info@parksavers.com. This includes any termination notices from employer, doctor's note signed and authorized by your physician, death certificate, or military orders for service.
Reimbursement of purchase price will not take place until the purchased items have reached their expiration. During this time guests who may have cancelled their trip due to the above listed reasons are still eligible to use their purchase until expiration. Upon expiration the guest will be paid out in full for the cancelled trip purchase (if not used already) and have submitted the required proof.
Trip Cancellation/Trip Interruption will not be paid out if any portion of the purchase has been used. 
    `;
  return (
    <div>
      <h4>Trip Interruption Insurance Terms and Conditions</h4>
      <textarea
        readOnly={true}
        style={{ width: "100%", height: "175px" }}
        value={terms}
      />
    </div>
  );
};

const MMTerms: React.SFC = () => {
  const terms = `Enjoy an unlimited array of photos taken by Disney PhotoPass photographers. including photos taken at select dining experiences and attractions. You can add photos to your account for 30 days (from the date of first download). All media you add within the 30 days can be downloaded (subject to the expiration policy) and shared with family and friends. Does not include photos taken within 3 days of purchase. Purchase is nonrefundable.`;
  return (
    <div>
      <h4>Terms and conditions for Memory Maker</h4>
      <textarea
        readOnly={true}
        style={{ width: "100%", height: "175px" }}
        value={terms}
      />
    </div>
  );
};

const GPTerms: React.SFC = () => {
  const terms = `For the price of $16 per ticket per day at Walt Disney World Resort and $20 per ticket per day at Disneyland Resort, choose the next available time to arrive at a variety of attractions and experiences using the Lightning Lane entrance. You can make one selection at a time, throughout the day – from classics like Haunted Mansion to thrill rides like Big Thunder Mountain Railroad and newer favorites like Millennium Falcon: Smugglers Run (attractions subject to limited availability). This convenient option is the next evolution of the fan-favorite Disney MaxPass service from Disneyland Resort. Disney Genie+ will also include Disney parks-themed audio experiences and photo features to capture your memories – augmented reality lenses for those visiting Walt Disney World Resort and unlimited Disney PhotoPass downloads from your day if you are visiting Disneyland Resort.`;
  return (
    <div>
      <h4>Terms and conditions for Genie+</h4>
      <textarea
        readOnly={true}
        style={{ width: "100%", height: "175px" }}
        value={terms}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Summary.tsx